<script setup lang="ts">
window.location.replace("http://vehaontzorgt.nl")
</script>